import Box from '@mui/material/Box';
import ReadOnlyTextEditor from '../../../../../../TextEditor/ReadOnlyTextEditor';
import './GroupReferencePreview.css';

const GroupReferencePreview = ({ question, markdown }) => {
  return (
    <>
      <Box className='group-question__preview'>
        {!markdown ? (
          <div className='group-question__line' />
        ) : (
          <ReadOnlyTextEditor content={question?.content || ''} />
        )}
      </Box>
    </>
  );
};

export default GroupReferencePreview;
